<template>
    <div class="dots">
        <div class="dot">{{ hours }}</div>H
        <div class="dot">{{ minutes }}</div>M
        <div class="dot">{{ seconds }}</div>S
    </div>
</template>

<script>
export default {
    data() {
        return {
            countDownDate: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            timer: null,
            isPageVisible: true
        };
    },
    created() {
        this.startCountDown();
    },
    props: {
        deadline: {
            type: Number,
            required: true
        }
    },
    methods: {
        startCountDown() {
            const that = this;

            // 更新剩余时间
            const updateCountdown = () => {
                let distance = that.deadline - Math.floor(Date.now() / 1000);

                if (distance <= 0) {
                    that.stopCountDown();
                    that.hours = 0;
                    that.minutes = 0;
                    that.seconds = 0;
                    that.$emit('frozen');
                    return;
                }

                that.hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
                that.minutes = Math.floor((distance % (60 * 60)) / 60);
                that.seconds = Math.floor(distance % 60);

                // 继续下一次更新
                that.timer = setTimeout(updateCountdown, 1000);
            };

            // 启动计时器
            this.timer = setTimeout(updateCountdown, 1000);
        },
        handleVisibilityChange() {
            if (document.visibilityState === 'visible') {
                this.isPageVisible = true;
                this.startCountDown();
            } else {
                this.isPageVisible = false;
                this.stopCountDown();
            }
        },
        stopCountDown() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        }
    },
    mounted() {
        console.log('CountdownComponent mounted');
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    beforeDestroy() {
        this.stopCountDown();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
};
</script>

<style lang="scss" scoped>
.dots {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #000000;

    .dot {
        width: 30px;
        height: 30px;
        margin: 0 5px;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        line-height: 30px;
        border-radius: 999px;
        border: 2px solid #A62C22;
    }
}
</style>